var map = {
	"./de.json": 2217,
	"./el.json": 2218,
	"./en.json": 2219,
	"./et.json": 2220,
	"./fil.json": 2221,
	"./gr.json": 2222,
	"./pl.json": 2223,
	"./ru.json": 2224,
	"./sv.json": 2225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2216;